
import { twicPreview } from '~/helpers/twicpics'

export default {
  name: 'ProductPage',
  async asyncData({ $db, $storyblok, params }) {
    const product = await $db.fetch('productBySlug', { slug: params.product })
    const boutique = await $storyblok.getStoryBySlug(
      `${params.ville}/${params.boutique}`
    )
    const related = await $db.fetch('productsBy', {
      key: 'storeName',
      param: product.storeName,
      limit: 6
    })
    return {
      product,
      boutique,
      relatedProducts: related.filter((r) => r.slug !== product.slug).slice(-5),
      selectedImageIndex: 0,
      selectedVariants: Object.keys(product.variants).reduce((acc, key) => {
        acc[key] = ''
        return acc
      }, {})
    }
  },
  computed: {
    heroImage() {
      return {
        name: 'blurry ' + this.product.images[0].name,
        url: twicPreview(
          this.product.images[0].url,
          'airtable',
          'https://dl.airtable.com/.attachments/'
        )
      }
    },
    filteredImages() {
      const copy = [...this.product.images]
      copy.splice(this.selectedImageIndex, 1)
      return copy
    },
    microdata() {
      return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: this.product.name,
        image: this.product.images.map((i) => i.url),
        description: this.product.description,
        offers: {
          '@type': 'Offer',
          price: this.product.price / 100,
          availability: 'https://schema.org/InStock',
          priceCurrency: 'EUR'
        }
      }
    }
  },
  created() {
    this.$store.commit('menu/setImage', this.product.storeLogo)
  },
  beforeDestroy() {
    this.$store.commit('menu/clear')
  },
  methods: {
    selectImage(id) {
      this.selectedImageIndex = this.product.images.findIndex(
        (img) => img.id === id
      )
    }
  },
  head() {
    return {
      title: `${this.product.name} - Grand'Rue - ${this.product.storeAddress}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.product.description
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.microdata
        }
      ]
    }
  }
}
